export const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

export const POPULATED_TOP_LEVEL_ZONE =
  process.env.VUE_APP_POPULATED_TOP_LEVEL_ZONE;

export const STAGE = process.env.VUE_APP_STAGE;

export const getModuleBaseUrl = () => {
  switch (STAGE) {
    case "local":
    case "test":
      return `https://test.modules.numprotocol.com/`;
    case "staging":
      return `https://staging.modules.numprotocol.com/`;
    default:
      return `https://modules.numprotocol.com/`;
  }
};

export const moduleUrl = (moduleId, fileName) => {
  if (!moduleId || !fileName)
    throw new Error("moduleId and fileName are both required");

  return `${getModuleBaseUrl()}${moduleId}/${fileName}.txt`;
};

export const claimUrl = numId => {
  switch (STAGE) {
    case "local":
    case "test":
      return `https://numserver.test.numops.com/claim/${numId}`;
    case "staging":
      return `https://numserver.staging.numops.com/claim/${numId}`;
    default:
      return `https://numserver.com/claim/${numId}`;
  }
};
